import { render, staticRenderFns } from "./AssetRowActions.vue?vue&type=template&id=48b61b68"
import script from "./AssetRowActions.vue?vue&type=script&lang=js"
export * from "./AssetRowActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports